import {
  EvaluatedCellMap,
  EvaluatedCellSheetMap,
  SheetNameDataMap
} from 'models/interfaces/spreadsheet-types/core-types';
import { SheetNameCellMap } from 'models/interfaces/spreadsheet-types/workbook-types';
import { TCells } from 'pages/ValuationsAllocation/approaches/DiscountCashFlow/components/EffectiveTaxRateLedger/types';

interface Scope {
  [sheetName: string]: TCells[];
}

/**
 * Parses expressions in the given scope.
 * @param {Scope} scope - The scope containing sheets and cells.
 */
export const parseExpressions = (scope: EvaluatedCellSheetMap): void => {
  Object.values(scope).forEach(sheet => {
    Object.values(sheet).forEach((cell: any) => {
      cell.initializeCellValue(sheet, scope);
    });
  });
};

/**
 * Calculates the values of cells in the given scope.
 * @param {Scope} scope - The scope containing sheets and cells.
 */
export const calcCells = (scope: EvaluatedCellSheetMap): void => {
  const topCells = Object.values(scope).flatMap(sheet =>
    Object.values(sheet).filter((cell: any) => cell.providers.size === 0)
  );
  topCells.forEach((cell: any) => {
    cell.calcValue();
  });
};

/**
 * Parses the given data and returns the references.
 * @param {Record<string, SpreadsheetConfig>} data - The data containing sheets and configurations.
 * @returns {Scope} The references containing sheets and cells.
 */
const parser = (data: SheetNameDataMap): EvaluatedCellSheetMap => {
  const references = Object.values(data).reduce((sofar, sheet) => {
    if (!sheet.cells) {
      return sofar;
    }
    // eslint-disable-next-line no-param-reassign
    sofar[sheet.name] = sheet.cells as EvaluatedCellMap;
    return sofar;
  }, {} as SheetNameCellMap);
  parseExpressions(references);
  calcCells(references);

  Object.values(data).forEach(sheet => {
    sheet.applyConditions(references);
  });
  return references;
};

export default parser;

